import React, { Component } from 'react';
import MyChart from './MyChart';

import { Line } from 'rc-progress';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker } from 'react-dates';

import CampaignList from '../Campaigns/CampaignList'
// import DataComponent from './DataComponent';

class Landing extends Component {

  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
    };
  }



	handleSelect(date){
	}

  render() {

    return (
      <div className="landing container_wrap">
        <h1>Dashboard</h1>

        <div className="row">
          
          <DateRangePicker
            startDateId="startDate"
            endDateId="endDate"
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onDatesChange={({ startDate, endDate }) => { this.setState({ startDate, endDate })}}
            focusedInput={this.state.focusedInput}
            onFocusChange={(focusedInput) => { this.setState({ focusedInput })}}
          />

        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">
              <h3>Spend</h3>
              <Line percent="10" trailWidth="2" strokeWidth="2" strokeColor="#4ab5eb" />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="card">
              <h4>Ad Spend</h4>
              <MyChart></MyChart>
            </div>
          </div>
          <div className="col-6">
            <div className="card">
              <h4>Ad CPC</h4>
              <MyChart></MyChart>
            </div>
          </div>
        </div>
        <div className="row">

          <div className="col-3">
            <div className="card">
              <h3>Conversions</h3>
              <h2>3000</h2>
            </div>
          </div>

          <div className="col-3">
            <div className="card">
              <h3>CPA</h3>
              <h2>£4</h2>
            </div>
          </div>

          <div className="col-3">
            <div className="card">
              <h3>CPC</h3>
              <h2>£.5</h2>
            </div>
          </div>

          <div className="col-3">
            <div className="card">
              <h3>Clicks</h3>
              <h2>3000</h2>
            </div>
          </div>

        </div>

<div className="row">
    <div className="col-12">
        <div className="card">
          <CampaignList />
        </div>
    </div>
</div>


      </div>
    );
  }
}

export default Landing;
